import type { MarketplaceIntegrationWithIdsFragment } from 'generated/resources/graphql'
import {
  AvailableIntegrationsDocument,
  IntegrationsCapabilityModeEnum,
  IntegrationsSyncRunOriginEnum,
} from 'generated/resources/graphql'

import { useEffect } from 'react'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

export interface AvailableIntegrationViewModel {
  capabilityMode: IntegrationsCapabilityModeEnum
  marketplaceIntegration: MarketplaceIntegrationWithIdsFragment
}

export const useAvailableIntegration = (
  origin: IntegrationsSyncRunOriginEnum,
  isBookkeeperView: boolean,
  companyId: string | undefined
): AvailableIntegrationViewModel | null => {
  const [fetchAvailableIntegrations, { data }] = useLazyQuery(AvailableIntegrationsDocument)

  useEffect(() => {
    if (!companyId) return

    fetchAvailableIntegrations({
      variables: {
        origin,
        companyId,
      },
      context: {
        isBookkeeperView,
      },
    })
    // origin and isBookkeeperView are intentionally omitted: they are static configuration values
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, fetchAvailableIntegrations])

  const node = data?.integrations?.availableIntegrationsConnection.nodes[0]

  if (!node) return null

  return {
    capabilityMode: node.capabilityMode,
    marketplaceIntegration: node.marketplaceIntegration,
  }
}
